export default {
  namespaced: true,
  state: {
    // 商品数据
    goodsInfoData: {
      id: '',
      baseGoodsId: '',
      sapCode: '',
      supplierCode: '',
      supplierName: '',
      sceneName: '',
      sceneType: '',
      goodsName: '',
      baseGoodsName: '',
      goodsCode: '',
      brandMerchantName: '',
      specificationType: '1',
      thumbUrl: [],
      goodsTypeName: '',
      goodsImgList: [],
      goodsId: [],
      specificationDetailList: [],
      upgradeGoodsList: [],
      distributionType: '0',
      goodsSpecificationNameList: [],
      status: '',
      goodsSpecificationList: [],
      goodsPositionList: [],
      applicableModelNames: '',
      positionNames: '',
      shoppingMallFlag: '0',
      goodsSpecificationSingleList: [],
      specificationSingleDetailList: [],
      selectedSceneCode: '',
      goodsType: '',
      baseGoodsNameEmpty: false,
      scrmFlag: 'N'
    }
  },
  mutations: {
    /**
     * @description 数据改变
     * @param {Object} state state
     */
    setUpdateGoodsInfo(state, data) {
      state.goodsInfoData = Object.assign(state.goodsInfoData, data)
    }
  },
  actions: {
  },
  getters: {
    getGoodsInfoData(state) {
      return state.goodsInfoData
    }
  }
}
